<div class="container" style="max-width:600px">
    <div class="row">
        <h2 style="border-bottom:1px solid grey;text-align:center">Our Staff</h2>
    </div>
    <div class="row">
        <h3 style="text-align:center">Coming Soon!</h3>
    </div>         
</div>